import React from "react";

const TemperatureDetails = ({ actualTemp, feelsLike, humidity }) => {
  // Calculate dew point using Magnus formula
  const calculateDewPoint = (temp, humidity) => {
    // Constants for Magnus formula
    const a = 17.27;
    const b = 237.7;

    // Calculate gamma
    const gamma = (a * temp) / (b + temp) + Math.log(humidity / 100);

    // Calculate dew point
    const dewPoint = (b * gamma) / (a - gamma);

    return dewPoint;
  };

  const dewPoint = calculateDewPoint(actualTemp, humidity);

  const getComfortLevel = (temp, dewPoint) => {
    const difference = temp - dewPoint;
    if (difference < 2) return { text: "Very Humid", color: "#F44336" };
    if (difference < 5) return { text: "Humid", color: "#FF9800" };
    if (difference < 10) return { text: "Comfortable", color: "#4CAF50" };
    if (difference < 15) return { text: "Dry", color: "#2196F3" };
    return { text: "Very Dry", color: "#9C27B0" };
  };

  const comfortLevel = getComfortLevel(actualTemp, dewPoint);

  return (
    <div className="bg-white rounded-lg p-4">
      <div className="grid grid-cols-3 gap-4 mb-4">
        <div className="text-center">
          <div className="text-sm text-gray-600">Actual</div>
          <div className="text-2xl font-bold">{Math.round(actualTemp)}°</div>
        </div>
        <div className="text-center">
          <div className="text-sm text-gray-600">Feels Like</div>
          <div className="text-2xl font-bold">{Math.round(feelsLike)}°</div>
        </div>
        <div className="text-center">
          <div className="text-sm text-gray-600">Dew Point</div>
          <div className="text-2xl font-bold">{Math.round(dewPoint)}°</div>
        </div>
      </div>

      <div className="mt-8">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm text-gray-600">Comfort Level</span>
          <span className="font-medium" style={{ color: comfortLevel.color }}>
            {comfortLevel.text}
          </span>
        </div>

        <div className="relative h-2 bg-gray-200 rounded-full overflow-hidden">
          <div
            className="absolute h-full rounded-full"
            style={{
              width: `${((actualTemp - dewPoint) / 20) * 100}%`,
              backgroundColor: comfortLevel.color,
            }}
          />
        </div>

        <div className="mt-4 text-sm text-gray-400">
          {comfortLevel.text === "Very Humid" &&
            "High humidity makes it feel much warmer than the actual temperature."}
          {comfortLevel.text === "Humid" &&
            "Moderate humidity makes it feel warmer than the actual temperature."}
          {comfortLevel.text === "Comfortable" &&
            "Current conditions are comfortable for most people."}
          {comfortLevel.text === "Dry" &&
            "Low humidity makes it feel cooler than the actual temperature."}
          {comfortLevel.text === "Very Dry" &&
            "Very low humidity can cause dry skin and respiratory discomfort."}
        </div>
      </div>
    </div>
  );
};

export default TemperatureDetails;
